import React ,{useState} from 'react'
import './organic_post_card.css'
import { getImgSrc, getPlatformImg } from '../../../helpers/getImgSrc'
import {useNavigate} from "react-router-dom"
import {FaGreaterThan} from 'react-icons/fa'
import { handleApi } from '../../../utils/authentication'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { getPlatformName } from '../../../helpers/getPlatformName'


const OrganicPostCard = ({postDetails,getCampaignList}) => {
    const navigate=useNavigate()
    const [disassociating,setDisassociating]=useState(false)
    const user=useSelector((state)=>state?.user)
    const [image,setImage]=useState(postDetails?.image_url)
  
    const disAsscoiateOrganicPost=async ()=>{
        try{
            setDisassociating(true)
            const formData=new FormData();
            formData.append('platform_id',postDetails?.platform_id)
            formData.append('program_id',postDetails?.program_id)
            formData.append('post_id',postDetails?.id)
            formData.append('is_mapped',postDetails?.is_mapped)
            formData.append('campaign_id',postDetails?.campaign_id)
            formData.append('client_id',user?.client_id)
            let result=await handleApi('link_internal_program_with_organic_post',"POST",{},formData)
            if(result?.success)
            {
                toast.success("The organic post has been successfully unlinked from the internal program.")
                getCampaignList()
            }else{
                 toast.error("Something went wrong; please try again later.")
            }
            
  

        }
        catch(e)
        {
            console.log(e)
            toast.error("Failed to unlink the post")
        }finally{
            setDisassociating(false)
        }

    }





  return (
     <div className="row px-1 py-3 my-2 campaign_item_card">
       <div className="col-lg-2 col-md-3 position-relative">
        <div className="campaign_item_card_poster position-relative"  style={{height:'7rem'}}>

            <img src={ image?image:getImgSrc('no_image_found','png')}  className="" 
             onError={()=>{
                setImage('')
             }}
            style={{height:'100% !important',width:'100% !important'}} alt="" />
            <div className="position-absolute bg-primary">

            </div>
        </div>


    </div>
    <div className="col-lg-10 col-md-9">
        <div
            className="d-flex flex-wrap justify-content-between  my-2 pb-2  border-bottom ">
            <div className="d-flex align-items-center gap-2 ">
                 <img src={getPlatformImg(postDetails?.platform_id)} className="img-fluid social_media_img" alt="" />
               
                <p className="mb-0 text_color_secondary">{postDetails?.name?.split(' ').length > 15
    ? postDetails.name.split(' ').slice(0, 15).join(' ') + '...'
    : postDetails?.name} Post</p>
            </div>
            <span>{postDetails?.platform_id?getPlatformName(postDetails?.platform_id):''} Platform</span>

        </div>
        <div className="row d-flex align-items-center mt-2">
            {getPlatformName(postDetails?.platform_id)=="Instagram"?
            <>
            <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0"> {Number(String(postDetails?.reach).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>
                   
                </div>
                <span>Reach</span>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0">{Number(String(postDetails?.likes).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>
                  
                </div>
                <span>Likes</span>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0"> {Number(String(postDetails?.share).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>
                 
                </div>
                <span>Share</span>
            </div>
            

            </>:<>
                 <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0"> {Number(String(postDetails?.share).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>
                   
                </div>
                <span>Share</span>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0"> {Number(String(postDetails?.impressions).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>
                  
                </div>
                <span>Impressions</span>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0"> {Number(String(postDetails?.clicks).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>
                 
                </div>
                <span>Clicks</span>
            </div>

            </>}
       

            <div className="col-lg-2 col-md-4 col-sm-4 col-6">
           
                
            </div>
                  <div className="col-4 d-flex gap-4 justify-content-end">
                      <button disabled={disassociating} onClick={disAsscoiateOrganicPost} 
                      className="btn  btn-primary btn-sm rounded-pill">{disassociating?"Please wait...":"Disassociate"}</button>

                      <button onClick={() => {
                       navigate(`/client/organic-social/view-more/${postDetails?.id}/${postDetails?.platform_id}`)
                      }} className="btn  btn-primary btn-sm rounded-pill">View More <FaGreaterThan /> </button>
                  </div>
              </div>

    </div>


</div>
  )
}

export default OrganicPostCard